<span class="m-i18n" v-html="text"></span>
